import {
    call,
    put,
    takeLatest,
} from 'redux-saga/effects';

// constants for endpoints
import {
    ALERTS,
} from "../../../components/global/Server/endpoints";
import { HTTP_SUCCESS } from "../../constants/global";


// constants for actions
import {
    FETCH_ALERTS, SNOOZE_ALERT, RESOLVE_ALERT, DELETE_ALL_ALERTS
} from "../../constants/alerts";
import { clearStatus, requestStatus, showErrorMessage } from "../../actions/global";
import {fetchAlerts, storeAlerts} from "../../actions/alerts";
import {SERVER_FAILED_ERROR_MESSAGE} from "../../../pages/Dashboard/constants";
import {storeResponseMessage} from "../../actions/settings";
import {getTableSetting} from "../../actions/account";
import AuthUtil from "../../AuthUtil";


function* fetchAlertsSaga(action) {
    yield call(clearStatus)
    try {
        const response = yield call(() => AuthUtil.postRequest(ALERTS.FETCH_ALERTS,action.data))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeAlerts(response.data))

        yield put(requestStatus(status));
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }

}

function* snoozeAlertsSaga(action) {
    yield call(clearStatus)
    try {
        const response = yield call(() => AuthUtil.postRequest(ALERTS.SNOOZE_ALERT, action.data))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(requestStatus(status));

        yield put(getTableSetting())
    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}
function* resolveAlertsSaga(action) {
    yield call(clearStatus)
    try {
        const response = yield call(() => AuthUtil.postRequest(ALERTS.RESOLVE_ALERT, action.data))
        if (response.data.success) {
            const status = {
                status: response.status,
                statusText: response.data.message,
                success: response.status === HTTP_SUCCESS,
            };
            yield put(storeResponseMessage(response.data.message))
            yield put(requestStatus(status))
        } else {
            const message = response.data.message || SERVER_FAILED_ERROR_MESSAGE
            yield put(showErrorMessage(message))
        }
        yield put(fetchAlerts({locationId: action.data.locationId}));

    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* deleteAllAlertsSaga(action) {
    yield call(clearStatus)
    try {
        const response = yield call(() => AuthUtil.postRequest(ALERTS.DELETE_ALL_ALERTS, action.data))
        if (response.data.success) {
            const status = {
                status: response.status,
                statusText: response.data.message,
                success: response.status === HTTP_SUCCESS,
            };
            yield put(storeResponseMessage(response.data.message))
            yield put(requestStatus(status))
        } else {
            const message = response.data.message || SERVER_FAILED_ERROR_MESSAGE
            yield put(showErrorMessage(message))
        }
        yield put(storeAlerts([]))

    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

export default function* alertsSaga() {
    yield takeLatest(FETCH_ALERTS, fetchAlertsSaga);
    yield takeLatest(SNOOZE_ALERT, snoozeAlertsSaga);
    yield takeLatest(RESOLVE_ALERT, resolveAlertsSaga);
    yield takeLatest(DELETE_ALL_ALERTS, deleteAllAlertsSaga);
}

